<template>
    <div class="loading-modal">
        <div class="sk-cube-grid">
            <div class="sk-cube sk-cube1" :class="colorClass"></div>
            <div class="sk-cube sk-cube2" :class="colorClass"></div>
            <div class="sk-cube sk-cube3" :class="colorClass"></div>
            <div class="sk-cube sk-cube4" :class="colorClass"></div>
            <div class="sk-cube sk-cube5" :class="colorClass"></div>
            <div class="sk-cube sk-cube6" :class="colorClass"></div>
            <div class="sk-cube sk-cube7" :class="colorClass"></div>
            <div class="sk-cube sk-cube8" :class="colorClass"></div>
            <div class="sk-cube sk-cube9" :class="colorClass"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "loading-modal",
        props: {
            color: {
                type: String,
                default: "color-red"
            }
        },
        computed: {
            colorClass() {
                switch (this.color) {
                    case "red":
                        return "color-red";
                        break;
                    case "green":
                        return "color-green";
                        break;
                    case "aqua":
                        return "color-aqua";
                        break;
                    case "purple":
                        return "color-purple";
                        break;
                    default:
                        return "color-red";
                }
            }
        }
    }
</script>

<style scoped>

    .loading-modal {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        bottom: 0;
        margin: auto;
        z-index: 100000;
    }

    .sk-cube-grid {
        width: 100px;
        height: 100px;
        margin: auto;
        position: absolute;
        top:0;
        bottom: 0;
        left: 0;
        right: 0;
    }

    .sk-cube-grid .sk-cube {
        width: 33%;
        height: 33%;
        background-color: #333;
        float: left;
        -webkit-animation: sk-cubeGridScaleDelay 1.3s infinite ease-in-out;
        animation: sk-cubeGridScaleDelay 1.3s infinite ease-in-out;
    }
    .sk-cube-grid .sk-cube1 {
        background-color: rgba(255, 0, 67, 1);
        -webkit-animation-delay: 0.2s;
        animation-delay: 0.2s; }
    .sk-cube-grid .sk-cube2 {
        background-color: rgba(255, 0, 67, 1);
        -webkit-animation-delay: 0.3s;
        animation-delay: 0.3s; }
    .sk-cube-grid .sk-cube3 {
        background-color: rgba(255, 0, 67, 1);
        -webkit-animation-delay: 0.4s;
        animation-delay: 0.4s; }
    .sk-cube-grid .sk-cube4 {
        background-color: rgba(255, 0, 67, 1);
        -webkit-animation-delay: 0.1s;
        animation-delay: 0.1s; }
    .sk-cube-grid .sk-cube5 {
        background-color: rgba(255, 0, 67, 1);
        -webkit-animation-delay: 0.2s;
        animation-delay: 0.2s; }
    .sk-cube-grid .sk-cube6 {
        background-color: rgba(255, 0, 67, 1);
        -webkit-animation-delay: 0.3s;
        animation-delay: 0.3s; }
    .sk-cube-grid .sk-cube7 {
        background-color: rgba(255, 0, 67, 1);
        -webkit-animation-delay: 0s;
        animation-delay: 0s; }
    .sk-cube-grid .sk-cube8 {
        background-color: rgba(255, 0, 67, 1);
        -webkit-animation-delay: 0.1s;
        animation-delay: 0.1s; }
    .sk-cube-grid .sk-cube9 {
        background-color: rgba(255, 0, 67, 1);
        -webkit-animation-delay: 0.2s;
        animation-delay: 0.2s; }

    @-webkit-keyframes sk-cubeGridScaleDelay {
        0%, 70%, 100% {
            -webkit-transform: scale3D(1, 1, 1);
            transform: scale3D(1, 1, 1);
        } 35% {
              -webkit-transform: scale3D(0, 0, 1);
              transform: scale3D(0, 0, 1);
          }
    }

    @keyframes sk-cubeGridScaleDelay {
        0%, 70%, 100% {
            -webkit-transform: scale3D(1, 1, 1);
            transform: scale3D(1, 1, 1);
        } 35% {
              -webkit-transform: scale3D(0, 0, 1);
              transform: scale3D(0, 0, 1);
          }
    }

    .color-red {
        background-color: rgba(255, 0, 67, 1) !important;
    }

    .color-green {
        background-color: rgba(0, 255, 169, 1) !important;
    }

    .color-purple {
        background-color: rgb(117, 32, 250) !important;
    }

    .color-aqua {
        background-color: rgb(68, 237, 251) !important;
    }

</style>



// WEBPACK FOOTER //
// src/components/modals/LoadingModal.vue